import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx and tailwind-merge for optimal className handling
 *
 * @param inputs - Class values to merge
 * @returns Merged className string
 *
 * @example
 * ```tsx
 * cn('px-4 py-2', 'bg-primary-500', someCondition && 'text-white')
 * ```
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Helper type that makes all optional properties also accept undefined explicitly.
 * Required when using exactOptionalPropertyTypes with spread operators on React
 * components that wrap Radix UI or other third-party primitives.
 */
export type WithUndefined<T> = {
  [K in keyof T]: undefined extends T[K] ? T[K] | undefined : T[K];
};
